import npConfig from "./nos.config";
// const npConfig = require("@/../nos.config");
import { npCommon, npDefine } from "./npCommon";
const NOSExtendUI = {
  pw: () => import("./NOSKeypadPW.vue"),
  idpw: () => import("./NOSKeypadIDPW.vue"),
  otp: () => import("./NOSKeypadOTP.vue"),
  motp: () => import("./NOSKeypadMOTP.vue"),
  advancedotp: () => import("./NOSKeypadAdvancedOTP.vue"),
  advancedunlock: () => import("./NOSKeypadAdvancedUnlock.vue"),
};
const NOSController = class NOSController {
  constructor(_vue, options) {
    this.vue = _vue;

    this.options = Object.assign(
      {
        componentid: "NOS_COMPONENT",
        npn: false,
        npk: false,
        npf: false,
        kpd: false,
      },
      options || {},
    );

    this.noscomponent = null;

    this.uuid = npCommon.makeUuid();

    this.keyset = {};

    this.keypadmap = {};
    // this.itemmap = {};
    this.components = [];

    this.initialized = false;
    this.absoluteUse = false;

    // console.log(this.functions);
    // console.log(this.inputs);

    // this.token = _vue.$store.getters.getToken;
    // this.checkedRefresh = false;
  }

  // https://stackoverflow.com/questions/48250832/programmatically-bind-custom-events-for-dynamic-components-in-vuejs?rq=1
  listeners() {
    const _this = this;
    // console.log(inst);
    const ret = {};
    if (_this.options.kpd) {
      // ret.focus = _this.vue.NOS_LISTNERS
      ret.focus = e => {
        // console.log(e);
        _this.handler(_this, e);
      };
      ret.update = e => {
        console.log(e);
        _this.handler(_this, e);
      };
    }
    return ret;
  }

  handler(instance, e) {
    // console.log("BroadCast Handler", arguments);
    // console.log("BroadCast Handler", instance, e);
    const _this = instance;
    const type = e.type;
    const targetid = e.target ? e.target.id || e.target.name : "";

    if (type === "focus") {
      // 다른 모든 키패드 숨기기
      _this.hideAll();

      // 해당 키패드 보이기
      if (targetid in _this.keypadmap && _this.isUseYn(targetid)) {
        this.visible(targetid, true);
        this.clear(targetid);
        this.focus(targetid);
      }
    }

    // if(type === "update") {
    //     console.log("Update....", e);
    // }
  }

  useynListeners(id) {
    if (!id) {
      console.log("사용여부 설정을 위해 해당 입력양식의 id 값을 지정해야 합니다.");
      return {};
    }

    const _this = this;
    const ret = {};
    if (_this.options.kpd) {
      if (npDefine.isMobileDevice()) {
        ret.touch = event => {
          // console.log(e);
          _this.useynHandler(_this, event, id);
        };
      } else {
        ret.click = event => {
          // console.log(e);
          _this.useynHandler(_this, event, id);
        };
      }
    }
    return ret;
  }

  useynHandler(instance, event, id) {
    const _this = instance;
    const type = event.type;
    if (type === "touch" || type === "click") {
      event.preventDefault();
      // console.log("useynHandler", id);
      _this.setUseYn(id, !_this.isUseYn(id));
      // if(_this.isUseYn(id)) {
      const ele = document.getElementById(id);
      // console.log(ele);
      if (ele) ele.focus();
      // }
    }
  }

  disabled() {
    let ret = this.absoluteUse;
    return ret;
  }

  isUseYn(id) {
    let ret = false;

    const keypad = this.find(id);
    // if(keypad) {
    //     console.log(keypad.isUseYn());
    // }
    if (keypad && keypad.isUseYn()) {
      ret = true;
    }

    return ret;
  }

  setUseYn(id, isuse) {
    const keypad = this.find(id);
    if (keypad) {
      keypad.setUseYn(isuse);
    }
  }

  visible(id, vis) {
    const keypad = this.find(id);
    if (keypad) {
      vis ? keypad.show() : keypad.hide();
    }
  }

  close(id) {
    const keypad = this.find(id);
    if (keypad) {
      keypad.close();
    }
  }

  // 다른 모든 키패드 숨기기
  hideAll() {
    Object.keys(this.keypadmap).forEach(id => {
      this.visible(id, false);
    });
  }

  closeAll() {
    Object.keys(this.keypadmap).forEach(id => {
      this.close(id);
    });
  }

  readonly(id) {
    const _this = this;
    if (id in _this.keypadmap && _this.isUseYn(id)) {
      // const keypadid = _this.keypadmap[id];
      // console.log("readonly", _this.isUseYn(id), id);
      return true;
    }
    return false;
  }

  clear(id) {
    const keypad = this.find(id);
    if (keypad) {
      keypad.clear(true);
    }
  }

  focus(id) {
    const keypad = this.find(id);
    if (keypad) {
      keypad.focus(true);
    }
  }

  destroy(id) {
    const _this = this;
    const keypad = this.find(id);
    if (id in _this.keypadmap && keypad) {
      const keypadid = _this.keypadmap[id];
      const len = _this.components.length;
      let i = len - 1;
      while (i >= 0) {
        const item = _this.components[i];
        if (item.id === keypadid) {
          console.log(item);
          _this.components.splice(i, 1);
        }
        i--;
      }
      delete _this.keypadmap[id];
    }
  }

  find(id) {
    let ret = null;
    const _this = this;
    const keypadid = _this.keypadmap[id];
    // console.log("Keypad value 1", id, keypadid);

    if (_this.noscomponent && id in _this.keypadmap && keypadid in _this.noscomponent.$refs) {
      const keypad = _this.noscomponent.$refs[keypadid];
      // console.log("Keypad 2", keypad);
      if (keypad && Array.isArray(keypad)) {
        keypad.some(kpd => {
          // console.log("Keypad 3", kpd);
          // console.log(kpd);
          ret = kpd;
          return true;
        });
      } else {
        ret = keypad;
      }
    }
    return ret;
  }

  toJSON() {
    const ret = {
      __E2E_UNIQUE__: this.uuid,
      // seedkey : this.seedkey,
      __E2E_KEYPAD__: this.keyset.rsakey,
      // seedkey3rd : this.seedkey3rd,
      __E2E_KEYPAD_EXT__: this.keyset.rsakey3rd,
    };

    Object.keys(this.keypadmap).forEach(id => {
      const keypadid = this.keypadmap[id];
      if (this.noscomponent && keypadid in this.noscomponent.$refs) {
        const keypad = this.noscomponent.$refs[keypadid];
        let value = {};
        if (keypad && Array.isArray(keypad)) {
          keypad.some(kpd => {
            // console.log("Keypad 3", kpd);
            // console.log(kpd);
            value = kpd.serialize();
            return true;
          });
        } else {
          value = keypad.serialize();
        }
        // ret[id] = value;
        Object.assign(ret, value);
      }
    });
    return ret;
  }

  text(id) {
    const _this = this;
    const value = _this.value(id);
    // console.log("Keypad value 1", id, value);
    if (value) {
      // console.log("text", value.textValue);
      return value.textValue;
    }
    return null;
  }

  value(id) {
    const keypad = this.find(id);
    return keypad ? keypad.value() : null;
  }

  async table(id) {
    const keypad = this.find(id);
    if (keypad) {
      const json = this.toJSON();
      const params = {
        p: "p",
        m: "t",
        u: json["__E2E_UNIQUE__"],
        r: json["__E2E_KEYPAD__"],
        k: keypad.getInfo(),
      };
      // console.log(params);

      const data = await npCommon.post(params);
      // console.log(data);
      return data;

      // npCommon.post(params)
      // .then((data) => {
      //   console.log(data);
      //   // 응답값에 따른 데이터 전처리
      //   if(typeof data === "object") {
      //     _this.info = data.info;
      //     _this.items = data.items;
      //   } else if(typeof data === "string") {
      //     const obj = JSON.parse(data);
      //     _this.info = obj.info;
      //     _this.items = obj.items;
      //   }
      // });
    }
    return null;
  }

  updateAbsoluteUse() {
    const _this = this;
    if (_this.options.kpd) {
      npConfig.isAbsoluteUse(function(res) {
        _this.absoluteUse = res;
      });
    }
  }

  async replacement(id) {
    const keypad = this.find(id);
    if (keypad) {
      const json = this.toJSON();
      const params = {
        p: "p",
        m: "r",
        u: json["__E2E_UNIQUE__"],
        r: json["__E2E_KEYPAD__"],
        k: keypad.getInfo(),
        v: keypad.getHash(),
      };
      // console.log(params);

      const data = await npCommon.post(params);
      // console.log(data);
      return data;

      // .then((data) => {
      //   console.log(data);
      //   // 응답값에 따른 데이터 전처리
      //   if(typeof data === "object") {
      //     _this.info = data.info;
      //     _this.items = data.items;
      //   } else if(typeof data === "string") {
      //     const obj = JSON.parse(data);
      //     _this.info = obj.info;
      //     _this.items = obj.items;
      //   }
      // });
    }
    return null;
  }

  async encrypt(id) {
    const keypad = this.find(id);
    if (keypad) {
      const json = this.toJSON();
      const params = {
        p: "p",
        m: "c",
        u: json["__E2E_UNIQUE__"],
        r: json["__E2E_KEYPAD__"],
        k: keypad.getInfo(),
        v: keypad.getHash(),
      };
      // console.log(params);

      const data = await npCommon.post(params);
      console.log(data);
      return data;
    }
    return null;
  }

  showLoading() {
    const noscomponent = this.noscomponent;
    if ("nppfs-loading" in noscomponent.$refs) noscomponent.$refs["nppfs-loading"].show();
  }

  hideLoading() {
    const noscomponent = this.noscomponent;
    if ("nppfs-loading" in noscomponent.$refs) noscomponent.$refs["nppfs-loading"].hide();
  }

  init() {
    // console.log("npBroadCast, UUID", this.uuid);
    const _this = this;

    (function() {
      return new Promise(function(resolve) {
        _this.noscomponent = _this.vue.$refs[_this.options.componentid];
        _this.showLoading();
        resolve();
      });
    })()
      .then(function() {
        return new Promise(function(resolve, reject) {
          if (_this.initialized) {
            resolve();
            return;
          }
          if (_this.options.npk || _this.options.npf) {
            const params = {
              p: "k", // _NOS_MODE_KEY_
              id: _this.uuid,
            };

            npCommon
              .post(params)
              .then(data => {
                // console.log("Key : ", data);
                _this.key = data;
                resolve();
              })
              .catch(err => {
                // console.log("Error Key : ", err);
                reject(err);
              });
          } else {
            resolve();
          }
        });
      })
      .then(function() {
        return new Promise(function(resolve, reject) {
          if (_this.initialized) {
            resolve();
            return;
          }
          if (_this.options.kpd) {
            const params = {
              p: "p",
              m: "p",
              u: _this.uuid,
            };

            npCommon
              .post(params)
              .then(data => {
                // console.log("Keypad Key : ", data);

                const rsa = npCommon.parsePublicKey(data);
                _this.keyset.seedkey = rsa.seedkey;
                _this.keyset.rsakey = rsa.rsakey;
                _this.keyset.rsa = rsa.rsa;
                _this.rsamessage = rsa.message;

                resolve();
              })
              .catch(err => {
                // console.log("Error Keypad Key : ", err);
                reject(err);
              });
          } else {
            resolve();
          }
        });
      })
      .then(function() {
        return new Promise(function(resolve, reject) {
          if (_this.initialized) {
            resolve();
            return;
          }
          if (_this.options.kpd && npConfig.KEYPAD["kpd-e2e-mode"] === "inca-double-encrypt") {
            const params = {
              p: "p",
              m: "p",
              u: _this.uuid,
              c: npConfig.KEYPAD["kpd-e2e-vendor"],
            };

            npCommon
              .post(params)
              .then(data => {
                // console.log("Keypad Key : ", data);

                const rsa = npCommon.parsePublicKey(data);
                _this.keyset.seedkey3rd = rsa.seedkey;
                _this.keyset.rsakey3rd = rsa.rsakey;
                _this.keyset.rsa3rd = rsa.rsa;

                resolve();
              })
              .catch(err => {
                console.log("Error Keypad Key : ", err);
                reject(err);
              });
          } else {
            resolve();
          }
        });
      })
      .then(function() {
        return new Promise(function(resolve) {
          if (_this.initialized) {
            resolve();
            return;
          }
          if (_this.options.kpd) {
            npConfig.isAbsoluteUse(function(res) {
              _this.absoluteUse = res;
              resolve();
            });
          } else {
            resolve();
          }
        });
      })
      .then(function() {
        return new Promise(function(resolve) {
          if (_this.initialized) {
            resolve();
            return;
          }
          if (!npConfig.KEYPAD["outside-hide"]) {
            resolve();
          }

          // jQuery UI의 Slider를 사용할 경우 이벤트가 충돌하여
          // 키패드 외부 마우스 클릭 시 키패드 닫아주는 기능이 정상동작하지 않음.
          // jQuery UI의 Slider가 있는지 확인하여 해당기능 활성/비활성화 by YGKIM @2016.10.27 with 김준희
          const sliders = document.getElementsByClassName("ui-slider");
          // console.log("Sliders ", sliders);
          if (sliders.length > 0) {
            resolve();
          }

          function findAncestor(el, sel) {
            while ((el = el.parentElement) && !(el.matches || el.matchesSelector).call(el, sel));
            return el;
          }
          function hasClass(el, clazz) {
            return (" " + el.className + " ").replace(/[\n\t]/g, " ").indexOf(" " + clazz + " ") > -1;
          }

          var doc = document.body;
          var eventkind = npDefine.isMobileDevice() ? { start: "touchstart", move: "touchmove", end: "touchend" } : { start: "mousedown", move: "mousemove", end: "mouseup" };

          doc.addEventListener(eventkind.start, function(event) {
            const target = event.target;
            // console.log("Target 111", target);
            const parent = findAncestor(target, ".nppfs-keypad-div");
            // console.log("Parent 111", parent);

            if (parent || hasClass(target, "nppfs-npv")) {
              return;
            }

            function handler(evt) {
              const target = evt.target;
              // console.log("Target 222", target);
              const parent = findAncestor(target, ".nppfs-keypad-div");
              // console.log("Parent 222", parent);
              if (parent || hasClass(target, "nppfs-npv")) {
                doc.removeEventListener(eventkind.end, handler);
                return;
              }

              if (evt.type === eventkind.end) {
                // click
                if (!npConfig.KEYPAD["outside-close"]) {
                  _this.closeAll();
                } else {
                  _this.hideAll();
                }
              } else {
                // drag
                //console.log("Drag");
              }

              doc.removeEventListener(eventkind.end, handler);
            }
            doc.addEventListener(eventkind.end, handler);
          });

          // 마우스입력기 초기화 완료 속성값 변경
          _this.initialized = true;
          resolve();
        });
      })
      .then(function() {
        return new Promise(function(resolve) {
          // npKpd
          if (!_this.options.kpd) {
            resolve();
            return;
          }
          // console.log(" _this.vue", _this.vue);
          // _this.vue.$children.forEach(item => {
          //     if(npConfig.E2E_ATTR_NAME in item.$attrs) {
          //         // console.log("mounted item", item);
          //         // const attval = item.$attrs[npConfig.E2E_ATTR_NAME];

          //         // const id = item.id || item.name;
          //         const id = item.id;
          //         if(!id) {
          //             const msg = "입력양식에 id 속성이 정의되어 있어야 합니다.";
          //             // const msg = "입력양식에 id 또는 name 속성이 정의되어 있어야 합니다.";
          //             // if(npConfig.DEBUG_MODE) alert(msg);
          //             // else
          //                 console.log(msg);
          //             return false;
          //         }
          //         if(id in _this.keypadmap) {
          //             const msg = "이미 초기화되었거나 입력양식의 id 속성이 중복됩니다.";
          //             // const msg = "이미 초기화되었거나 입력양식의 id 또는 name 속성이 중복됩니다.";
          //             // if(npConfig.DEBUG_MODE) alert(msg);
          //             // else
          //                 console.log(msg);
          //             return false;
          //         }

          //         // console.log("mounted attrs", item.$attrs);
          //         // console.log("mounted focus", item.$focus);
          //         // console.log("mounted listners", item.$listeners);

          //         // const nosInput = require("./NOSInput").default;
          //         const keypad = (() => import('./NOSKeypad'));
          //         // component.$options.props = Object.assign({}, component.$options.props, {referer: input});

          //         // https://www.raymondcamden.com/2018/10/31/working-with-dynamic-components-in-vuejs
          //         // console.log("nosInput", component);
          //         // nosInput.props["referer"] = input;
          //         // component.setParent(input);
          //         const element_id = "nos-input-" + id

          //         _this.keypadmap[id] = element_id;
          //         _this.itemmap[id] = item;
          //         _this.components.push({
          //             component : keypad,
          //             id: element_id,
          //             ref: element_id,
          //             props: {
          //                 input : item,
          //                 uuid: _this.uuid,
          //                 // rsakey: (attval !== "db") ? _this.rsakey : _this.rsakey3rd,
          //                 keyset: _this.keyset,
          //             },
          //             events : {
          //                 update: (arg) => {
          //                     // console.log("Event from NOSInput", item.$data);
          //                     // // item.$emit("update", _this.value(id));
          //                     // // item.vModelValue = arg.textValue;
          //                     // // item.localValue = arg.textValue;
          //                     // // _this.vue.$set(item, "a", _this.text(id));
          //                     // // item.$el.value = _this.text(id);
          //                     // // item.updateValue(_this.text(id));
          //                     // // item.modifyValue(_this.text(id));
          //                     // // item.value = _this.text(id);
          //                     item.vModelValue = _this.text(id);
          //                     item.localValue = _this.text(id);
          //                     item.$emit("update", _this.text(id));
          //                     item.$emit("input", _this.text(id));
          //                 },
          //                 hideall: () => {
          //                     _this.hideAll();
          //                 }
          //             },
          //         });

          //     }
          // });

          const inputs = _this.vue.$el.getElementsByTagName("input");
          // console.log("inputs", inputs);
          for (let i = 0; i < inputs.length; i++) {
            const item = inputs[i];
            // console.log("inputs => item", item);

            const attr = item.getAttribute(npConfig.E2E_ATTR_NAME);
            if (attr) {
              // console.log("mounted item", item);
              // const attval = item.$attrs[npConfig.E2E_ATTR_NAME];

              // const id = item.id || item.name;
              const id = item.id;
              if (!id) {
                const msg = "입력양식에 id 속성이 정의되어 있어야 합니다.";
                // const msg = "입력양식에 id 또는 name 속성이 정의되어 있어야 합니다.";
                // if(npConfig.DEBUG_MODE) alert(msg);
                // else
                console.log(msg);
                // return false;
                continue;
              }
              if (id in _this.keypadmap) {
                const msg = "이미 초기화되었거나 입력양식의 id 속성이 중복됩니다.";
                // const msg = "이미 초기화되었거나 입력양식의 id 또는 name 속성이 중복됩니다.";
                // if(npConfig.DEBUG_MODE) alert(msg);
                // else
                console.log(msg);
                // return false;
                continue;
              }

              // console.log("mounted attrs", item.$attrs);
              // console.log("mounted focus", item.$focus);
              // console.log("mounted listners", item.$listeners);

              // const nosInput = require("./NOSInput").default;
              //const keypad = (() => import('./NOSKeypad'));
              var extui = item.getAttribute("data-keypad-extend-ui");
              const keypad = NOSExtendUI[extui] ? NOSExtendUI[extui] : () => import("./NOSKeypad.vue");
              // component.$options.props = Object.assign({}, component.$options.props, {referer: input});

              // https://www.raymondcamden.com/2018/10/31/working-with-dynamic-components-in-vuejs
              // console.log("nosInput", component);
              // nosInput.props["referer"] = input;
              // component.setParent(input);
              const element_id = "nos-input-" + id;

              _this.keypadmap[id] = element_id;
              // _this.itemmap[id] = item;
              _this.components.push({
                component: keypad,
                id: element_id,
                ref: element_id,
                props: {
                  input: item,
                  uuid: _this.uuid,
                  // rsakey: (attval !== "db") ? _this.rsakey : _this.rsakey3rd,
                  keyset: _this.keyset,
                },
                events: {
                  update: () => {
                    // console.log("Event from NOSInput 111", item);
                    // console.log("Event from NOSInput 222", _this.text(id));
                    // // item.$emit("update", _this.value(id));
                    // // item.vModelValue = arg.textValue;
                    // // item.localValue = arg.textValue;
                    // // _this.vue.$set(item, "a", _this.text(id));
                    // // item.$el.value = _this.text(id);
                    // // item.updateValue(_this.text(id));
                    // // item.modifyValue(_this.text(id));
                    item.value = _this.text(id);
                    item.vModelValue = _this.text(id);
                    item.localValue = _this.text(id);

                    // console.log("input.......", _this.vue.$refs[id]);
                    // const component = _this.vue.$refs[id];
                    // if(component && component.$emit) {
                    //     console.log("Event from NOSInput 333", _this.text(id));
                    //     component.$emit("update", _this.text(id));
                    //     component.$emit("input", _this.text(id));
                    // }
                    item.dispatchEvent(new Event("input"));
                    item.dispatchEvent(new Event("change"));
                    // item.$emit("input", _this.text(id));
                    // _this.vue.$emit("input", _this.text(id));
                  },
                  hideall: () => {
                    _this.hideAll();
                  },
                },
              });
            }
          }
          resolve();
        });
      })
      .then(function() {
        // console.log("Key : ", _this.key);
        // console.log("Keypad KeySet : ", _this.keyset);
        // console.log("Keypad Key rsamessage : ", _this.rsamessage);
        // 마우스입력기 초기화 이후에 강제사용여부 업데이트
        _this.updateAbsoluteUse();
        _this.hideLoading();
      })
      .catch(err => {
        console.log("Error : ", err);
        _this.hideLoading();
      });
  }
};

export default NOSController;
